import { css, cx } from "@linaria/core";

export const className = css`
  display: block;

  /**
   * svg implements it's own pointer event system, which rarely works the way
   * you'd expect usually - simply disable pointer events all together to avoid
   * confusion.
   */
  pointer-events: none;
`;

export function SVG(
  props: React.DetailedHTMLProps<
    React.SVGAttributes<SVGSVGElement>,
    SVGSVGElement
  >,
) {
  return <svg {...props} className={cx(className, props.className)} />;
}
